module.exports = __webpack_public_path__ + "static/img/light_logo.9254fd58.png";